import { render, staticRenderFns } from "./UploadSingleImage.vue?vue&type=template&id=0a1dfdba&"
import script from "./UploadSingleImage.vue?vue&type=script&lang=js&"
export * from "./UploadSingleImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadSingleImage.vue?vue&type=style&index=0&id=0a1dfdba&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports